<template>
  <div class="advance-setting">
    <v-layout>
      <v-flex class="input-label" xs2>文字コード</v-flex>
      <v-flex xs10>
        <v-select
          v-model="encodeText"
          :items="encodeTextItems"
          class="select-box"
          menu-props="auto"
          hide-details
          dence
        />
      </v-flex>
    </v-layout>
    <v-layout v-if="!form.query.isInsertionOrderBudgetInterval()">
      <v-flex class="input-label" xs2>予算を表示する</v-flex>
      <v-flex xs10>
        <v-switch
          v-model="isIncludeBudget"
          :label="isIncludeBudgetText"
          class="iconStyles"
          color="info"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Encode from '@/constants/encode'

const encodeItems = [Encode.SHIFT_JIS, Encode.UTF_8]

export default {
  name: 'IntervalReportModalAddAdvanceSetting',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    encodeTextItems() {
      return encodeItems
    },
    encodeText: {
      get() {
        return this.form.notification.encode
      },
      set(text) {
        this.form.notification.encode = text
      },
    },
    isIncludeBudget: {
      get() {
        return this.form.query.isIncludeBudget
      },
      set(boolean) {
        this.form.query.isIncludeBudget = boolean
      },
    },
    isIncludeBudgetText() {
      return this.isIncludeBudget ? '表示する' : '表示しない'
    },
  },
}
</script>

<style scoped lang="scss">
.mt-4 {
  margin: 0;
}
.v-input {
  padding: 0;
  margin: 14px 0;
}
.advance-setting {
  padding: 0;
  margin: 0 0 0 25px;
}
.input-label {
  padding-top: 20px;
  color: #616161 !important;
  caret-color: #616161 !important;
}
.select-box {
  max-width: 140px;
}
.iconStyles {
  padding-top: 5px;
  display: inline-block !important;
  .v-input__slot {
    margin: 0 !important;
  }
}
</style>
